export const EDIT_DASHBOARD_NAME = "edit_dashboard";
export const EDIT_DASHBOARD_DESC = `Edits an existing dashboard via GraphQL mutation.

Use when the user asks to rename a dashboard or update its description.

Input:
- 'dashboardId' (required): Target dashboard ID to update.
- 'name' (optional): New dashboard name.
- 'description' (optional): New description text.
- 'organizationId' (optional): Workspace/organization ID used only for building navigation helpers.

Notes:
- Provide at least one of 'name' or 'description'.
- Returns updated dashboard fields plus convenience links when available.`;
